/* UNFROZEN · script de la page vidéo · 02/10/2026
   1. Le lecteur : démarrage muet avec un bouton « écouter », pause au toucher, aucune barre de durée.
   2. La zone d'offre [data-uf-offre] : fermée au chargement, ouverte quand la vidéo atteint data-reveal-at secondes.
      C'est le mécanisme de la page de Halsten : un sondage du temps de lecture toutes les 500 ms, puis une classe ajoutée.
      Il lit le lecteur intégré (<video data-uf-lecteur>) et, s'il y en a un, un lecteur VTurb (window.smartplayer).
      Une fois ouverte, la zone le reste pour cette visiteuse (mémoire du navigateur). ?offre=1 dans l'adresse l'ouvre tout de suite (contrôle).
   3. La barre collée en bas de l'écran (lettre de vente) s'efface quand le pied de page est visible.
   4. Rien d'autre : la FAQ utilise <details>, sans script. */
(function () {
  "use strict";
  var CLE = "uf-offre-ouverte";

  function poser(el) {
    if (el.classList.contains("est-ouverte")) return;
    el.classList.add("est-ouverte");
    window.setTimeout(function () { el.classList.add("est-posee"); }, 1000);   // après la transition : plus de hauteur maximale (les réponses de la FAQ se déplient)
  }
  function ouvrir() {
    var z = document.querySelectorAll("[data-uf-offre]"), i;
    for (i = 0; i < z.length; i++) poser(z[i]);
    try { window.localStorage.setItem(CLE, "1"); } catch (e) {}
  }
  function tempsLecteurExterne() {
    var sp = window.smartplayer, t = 0, i, v;
    if (sp && sp.instances) {
      for (i = 0; i < sp.instances.length; i++) {
        v = sp.instances[i] && sp.instances[i].video;
        if (v && v.currentTime > t) t = v.currentTime;
      }
    }
    return t;
  }
  function init() {
    var deja = false;
    try { deja = window.localStorage.getItem(CLE) === "1"; } catch (e) {}
    if (deja || /[?&]offre=1\b/.test(window.location.search)) ouvrir();

    var bloc = document.querySelector("[data-uf-video]");
    if (!bloc) return;
    var seuil = parseFloat(bloc.getAttribute("data-reveal-at") || "0");
    var video = bloc.querySelector("video[data-uf-lecteur]");
    var son = bloc.querySelector("[data-uf-son]");
    var pause = bloc.querySelector("[data-uf-pause]");

    if (video) {
      // démarrage muet : les navigateurs n'autorisent le son qu'après un geste
      video.muted = true;
      if (video.getAttribute("src")) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      if (son) son.addEventListener("click", function (ev) {
        ev.stopPropagation();
        video.muted = false;
        try { video.currentTime = 0; } catch (e) {}
        var q = video.play(); if (q && q.catch) q.catch(function () {});
        son.setAttribute("hidden", "");
      });
      bloc.addEventListener("click", function () {
        if (son && !son.hasAttribute("hidden")) return;       // tant que le bouton « écouter » est là, c'est lui qui répond
        if (video.paused) { var r = video.play(); if (r && r.catch) r.catch(function () {}); if (pause) pause.setAttribute("hidden", ""); }
        else { video.pause(); if (pause) pause.removeAttribute("hidden"); }
      });
      video.addEventListener("ended", function () { if (!video.muted) ouvrir(); });
    }
    if (seuil > 0) {
      window.setInterval(function () {
        var t = tempsLecteurExterne();
        if (video && !video.muted && video.currentTime > t) t = video.currentTime;
        if (t >= seuil) ouvrir();
      }, 500);
    }
  }
  // La barre collée en bas de l'écran s'efface quand le pied de page est visible (même règle que chez Halsten).
  function barre() {
    var b = document.querySelector("[data-uf-barre]"), pied = document.querySelector(".uf-pied");
    if (!b || !pied || !("IntersectionObserver" in window)) return;
    new window.IntersectionObserver(function (e) {
      document.documentElement.classList.toggle("uf-pied-visible", e[e.length - 1].isIntersecting);
    }, { threshold: 0 }).observe(pied);
  }
  function demarrer() { init(); barre(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer); else demarrer();
})();
/* UNFROZEN · 03/10/2026 · les onglets et le carrousel d'avis de la page courte (comme chez Halsten).
   Onglets [data-uf-onglets] : un clic sur un onglet montre son panneau. Dans l'éditeur du thème, choisir un bloc rangé dans un onglet
   ouvre cet onglet. Carrousel [data-uf-carr] : la flèche fait défiler d'une carte. */
(function () {
  "use strict";
  function montrer(c, i) {
    if (!c) return;
    Array.prototype.forEach.call(c.children, function (el) {
      if (el.classList.contains("uf-onglets__barre")) {
        Array.prototype.forEach.call(el.children, function (t) { t.classList.toggle("est-actif", t.getAttribute("data-i") === String(i)); });
      } else if (el.classList.contains("uf-onglets__panneau")) {
        el.classList.toggle("est-actif", el.getAttribute("data-i") === String(i));
      }
    });
  }
  function lier() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-uf-onglets]:not([data-lie])"), function (c) {
      c.setAttribute("data-lie", "1");
      c.addEventListener("click", function (e) {
        var t = e.target.closest ? e.target.closest(".uf-onglets__tab") : null;
        if (t && t.parentNode && t.parentNode.parentNode === c) montrer(c, t.getAttribute("data-i"));
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-uf-carr]:not([data-lie])"), function (c) {
      c.setAttribute("data-lie", "1");
      var piste = c.querySelector(".uf-carr__piste"), b = c.querySelector(".uf-carr__suiv");
      if (!piste || !b) return;
      b.addEventListener("click", function () {
        var carte = piste.firstElementChild, pas = carte ? carte.getBoundingClientRect().width + 14 : piste.clientWidth;
        if (piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 4) piste.scrollTo({ left: 0, behavior: "smooth" });
        else piste.scrollBy({ left: pas, behavior: "smooth" });
      });
    });
  }
  document.addEventListener("shopify:block:select", function (e) {
    var el = e.target, p = el && el.closest ? el.closest(".uf-onglets__panneau") : null;
    if (p) montrer(p.parentNode, p.getAttribute("data-i"));
  });
  document.addEventListener("shopify:section:load", lier);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", lier); else lier();
})();
